import logo from '../images/cams_logo.svg';
import IConAddDate from '../images/icon-add.svg';
import IconDelete from '../images/icon-close.svg';
import IconColorMan from '../images/icon-color-man.svg';
import arrowright from './arrowright.svg';
import book from './book.png';
import Cams from './Cams.svg';
import masterCard from './card-master-card.svg';
import IconCourseMaterial from './icon-course-material.svg';
import IconCourseObjectives from './icon-course-objectives.svg';
import iconDropdown from './icon-dropdown.svg';
import IconGetHelp from './icon-get-help.svg';
import IconGetStarted from './icon-get-started.svg';
import IconPencil from './icon-pencil.svg';
import arrowBackIcon from './arrow_back_icon.svg';
import arrowDownBlueIcon from './icons/arrow_down_blue_icon.png';
import arrowDownDarkCeruleanIcon from './arrow-bottom@2x.png';
import cartIcon from './icons/cart-icon.svg';
import cartIconThin from './icons/cart-icon-thin.png';
import accountIcon from './icons/account-icon.svg';
import closeIcon from './icons/close_icon.png';
import closeGreyIcon from './icons/close-grey-icon.svg';
import dropdownIcon from './icons/dropdown_icon.svg';
import editIcon from './edit-icon.svg';
import loginInstead from './login_instead.svg';
import menuToggleIcon from './icons/menu_toggle_icon.png';
import settingIcon from './setting-icon.svg';
import signOutIcon from './signout-icon.svg';
import tickIcon from './tick_icon.svg';
import IconsCheckCompleted from './IconsCheckCompleted.svg';
import IconsCheckNormal from './IconsCheckNormal.svg';
import IconsFAangle from './IconsFAangle.svg';
import IconsFAinfoCircle from './IconsFAinfo-circle.svg';
import IconsFAinfoGrey from './IconsFAinfoGrey.svg';
import ContentCourse from './img-content-course.png';
import myprofessional from './myprofessional.svg';
import mytraining from './mytraining.svg';
import Path7 from './Path 7.svg';
import IconPlay from './play icon.svg';
import IconCorrect from './tick.png';
import visaCard from './visa-card.svg';
import Group2 from './Group 2.svg';
import IconsFAangleSum from './IconsFAangleSum.svg';
import IconsFAangleSubtract from './IconsFAangleSubtraction.svg';
import iconAddCart from './icon-add-to-cart.svg';
import iconCartClear from './icon-cart-modal.svg';
import iconInfoGray from './Iconsinfo-circle.svg';
import iconLogin from './iconLogin.svg';
import IconFAInforDark from './IconsFAinfo-Dark.svg';
import IconClosed from './RemovePopup.svg';
import arrowBlueHighlight from './arrow-blue-highlight.svg';
import IconAuthorizeArrowRight from './authorize_icon_arrow_right.svg';
import IconManPeoplePersonUser from './man_people_person_user_icon.svg';
import IconManPeopleOrganizationUser from './man_people_organization_user_icon.svg';
import IconShape from './shape@2x.png';
import IconMultiUser from '../images/multi-user.svg';
import IconSeat from '../images/icon-seat.svg';
import IconTrack from '../images/icon-track.svg';
import IconSignOutOrg from '../images/icon-signout-org.svg';
import IconPlus from '../images/icons/plus-icon.png';
import IconMinimize from './IconMinimize.svg';
import IconMaximize from './IconMaximize.svg';
import blueRightArrow from './blueRightArrow.svg';
import lightBlueRightArrow from './lightBlueRightArrow.svg';
import IconsCheckShipping from './IconsCheckShipping.svg';
import IconDesignationCheck from './designation-check.svg';
import IconDesignationUncheck from './designation-uncheck.svg';
import IconDesignationComplete from './designation-complete.svg';
import IconDesignationDropdown from './designation-icon-dropdown.svg';

import BgBanner from './bg-banner.png';

// import edit_icon from './icons/edit-icon.png';

const logoMain = 'https://training-cams-care-assets.s3.us-east-1.amazonaws.com/media/cams_logo_main-52990192.svg';
const logoFooter = 'https://training-cams-care-assets.s3.us-east-1.amazonaws.com/media/cams_logo_footer-53275957.svg';

const images = {
     logo,
     logoMain,
     logoFooter,
     cartIcon,
     cartIconThin,
     accountIcon,
     arrowBackIcon,
     arrowDownBlueIcon,
     arrowDownDarkCeruleanIcon,
     closeIcon,
     closeGreyIcon,
     menuToggleIcon,
     settingIcon,
     signOutIcon,
     dropdownIcon,
     tickIcon,
     loginInstead,
     visaCard,
     masterCard,
     IconsCheckNormal,
     IconsFAinfoCircle,
     IconsFAinfoGrey,
     IconsFAangle,
     mytraining,
     myprofessional,
     Cams,
     arrowright,
     editIcon,
     IconColorMan,
     IconDelete,
     IConAddDate,
     book,
     iconDropdown,
     IconsCheckCompleted,
     Path7,
     IconCorrect,
     IconPencil,
     IconGetStarted,
     IconGetHelp,
     IconCourseObjectives,
     IconCourseMaterial,
     IconPlay,
     ContentCourse,
     Group2,
     IconsFAangleSubtract,
     IconsFAangleSum,
     iconAddCart,
     iconCartClear,
     iconInfoGray,
     iconLogin,
     IconFAInforDark,
     IconClosed,
     arrowBlueHighlight,
     IconAuthorizeArrowRight,
     IconManPeoplePersonUser,
     IconManPeopleOrganizationUser,
     IconShape,
     IconMultiUser,
     IconSeat,
     IconTrack,
     IconSignOutOrg,
     IconPlus,
     IconMinimize,
     IconMaximize,
     blueRightArrow,
     lightBlueRightArrow,
     IconsCheckShipping,
     IconDesignationCheck,
     IconDesignationUncheck,
     IconDesignationComplete,
     IconDesignationDropdown,

     BgBanner,
};
export default images;
